<template>
  <div>
    <transition name="fade">
      <component
        :is="layout"
        v-if="fetched">
        <transition name="switch">
          <router-view :key="$route.fullPath" />
        </transition>
      </component>
    </transition>
    <products-search-popup
      v-if="productsSearchPopupIsOpen"
      :currency-id="-1"
      :products-discount="0"
      :selected-currency-symbol="'PLN'"
      :product-index="0"
      :selected-tag-category="null"
      :selected-tag-category-value="null"
      :tag-categories="tagCategories"
      :hide-buttons="true" />

    <container-search-popup
      v-if="containerPreviewPopupIsOpen"
      :productID="containerPreviewProductID"
      :productCode="containerPreviewProductCode"
      :previewMode="true" />
  </div>
</template>

<script>
import FormUtils from './utils/FormUtils.js';
import SanitizeUtils from './utils/SanitizeUtils.js';
import ProductsSearchPopup from './components/orders/ProductsSearchPopup.vue';
import ContainerSearchPopup from './components/orders/ContainerSearchPopup.vue';

export default {
  name: 'App',
  components: {
    'products-search-popup': ProductsSearchPopup,
    'container-search-popup': ContainerSearchPopup
  },
  data () {
    return {
      fetched: false,
      user: {},
      loadUserError: false,
      loadedTagCategories: false,
      tagCategories: [],
      productsSearchPopupIsOpen: false,
      containerPreviewPopupIsOpen: false,
      containerPreviewProductID: 0,
      containerPreviewProductCode: ''
    }
  },
  computed: {
    layout () {
      if (!this.$route.meta) {
        return 'default-layout';
      }

      return `${this.$route.meta.layout || 'default'}-layout`;
    },
  },
  mounted () {
    let self = this;

    window.crmApp = {
      permissionsAvailable () {
        return self.$store.state && self.$store.state.user && self.$store.state.user.permissions;
      },
      hasPermissions (permissionName) {
        return self.$store.state.user.permissions && self.$store.state.user.permissions[permissionName];
      }
    };

    this.$bus.$on('products-search-popup-close', this.closeProductsSearchPopup);
    this.$bus.$on('container-preview-popup-open', this.openContainerPreviewPopup);
    this.$bus.$on('container-preview-popup-close', this.closeContainerPreviewPopup);

    let notLoggedInRoutes = [
      'Logowanie',
      'Prośba o reset hasła',
      'Reset hasła',
      'Rejestracja',
      'Wyloguj'
    ];

    if (!SanitizeUtils.getToken() && notLoggedInRoutes.indexOf(this.$route.name) === -1) {
      this.fetched = true;
      this.$router.push('/logowanie');
      return;
    }

    if (notLoggedInRoutes.indexOf(this.$route.name) !== -1) {
      this.fetched = true;
      return;
    }

    FormUtils.loadAdditionalData(this, {
      endpoint: '/users/item/me',
      outputKey: 'user',
      errorKey: 'loadUserError',
      successAction: (response) => {
        this.fetched = true;

        if (response && response.id && response.type === 'customer' && response.permissions.partner_customers) {
          this.$store.commit('setCustomerID', response.customer_id);
          this.$store.commit('setParentID', response.parent_id);
          this.$store.commit('setUserID', response.id);
          this.$store.commit('setUserName', response.name);
          this.$store.commit('setUserEmail', response.email);
          this.$store.commit('setUserPermissions', response.permissions);
          this.$store.commit('setUserType', response.type);
          this.$store.commit('setUserLang', response.language_id);

          let languageCode = 'pl';

          if (response.language_code) {
            languageCode = response.language_code.toLocaleLowerCase();
          }

          if (languageCode && this.$i18n.locale !== languageCode) {
            window.localStorage.setItem('headwear-crm-ui-language', languageCode.replace(/[^a-z]/gmi, ''));
            window.location.reload();
          }

          FormUtils.loadAdditionalData(this, {
            endpoint: '/customer-panel/tags/categories/items',
            loadedKey: 'loadedTagCategories',
            outputKey: 'tagCategories',
            errorKey: 'loadError',
            params: {
              with: ['tags']
            }
          });
        } else {
          this.$router.push('/wyloguj');
        }
      }
    });
  },
  methods: {
    openProductsSearchPopup () {
      this.productsSearchPopupIsOpen = true;
    },
    closeProductsSearchPopup () {
      this.productsSearchPopupIsOpen = false;
    },
    openContainerPreviewPopup (productID, productCode) {
      this.containerPreviewProductID = productID;
      this.containerPreviewProductCode = productCode || '';
      this.containerPreviewPopupIsOpen = true;
    },
    closeContainerPreviewPopup () {
      this.containerPreviewPopupIsOpen = false;
      this.containerPreviewProductID = 0;
      this.containerPreviewProductCode = '';
    }
  },
  beforeDestroy() {
    this.$bus.$off('products-search-popup-close', this.closeProductsSearchPopup);
    this.$bus.$off('container-preview-popup-open', this.openContainerPreviewPopup);
    this.$bus.$off('container-preview-popup-close', this.closeContainerPreviewPopup);
  }
};
</script>

<style lang="scss">
@import './assets/scss/custom-elements.scss';

.switch-enter-to,
.switch-leave-to {
  transition: opacity .25s ease-out;
}

.switch-enter,
.switch-leave-to {
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  transform: none;
  width: 100%;
}
</style>
